export default "__VITE_ASSET__fikVWMQZ__"